<template>
  <div id="alterations">
    <div class="header flex-between">
      <div class="header-text">
        <h1>客户企微好友关系报表</h1>
      </div>
      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="el-icon-notebook-2"
          @click="conditionDialog = true"
          >展开\隐藏条件</el-button
        >
        <el-button
          v-if="jurisdiction.search"
          icon="iconfont icon-sousuo1"
          @click="getList()"
          >查询</el-button
        >
        <el-button v-if="jurisdiction.search" @click="eliminate"
          >清除查询条件</el-button
        >
        <el-button v-if="jurisdiction.export" @click="exportShow = true"
          >导出</el-button
        >
        <el-button
          icon="el-icon-download"
          v-if="jurisdiction.export"
          @click="(downloadShow = true), getDownladList()"
          >下载</el-button
        >
      </div>
    </div>
    <!-- 首页查询card -->
    <el-card shadow="never">
      <div class="searchform">
        <el-form label-width="160px" :model="queryInfo" size="small">
          <el-row>
            <el-col :span="7">
              <el-form-item label="会员姓名\卡号\手机号">
                <el-input
                  v-model="queryInfo.cusInfo"
                  style="width: 80%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label-width="60px" label="">
                <el-checkbox v-model="queryInfo.multipleQty"
                  >好友数量大于等于2人</el-checkbox
                >
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="60px" label="">
                <el-checkbox-group v-model="queryInfo.checkList">
                  <el-checkbox label="本店"></el-checkbox>
                  <el-checkbox label="跨区"></el-checkbox>
                  <el-checkbox label="跨店"></el-checkbox>
                  <el-checkbox label="其他"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <div>
      <el-card shadow="never" calss="centercard">
        <el-table
          :key="key"
          size="small"
          class="table-style"
          :height="isMore ? 'calc(100vh - 24.3rem)' : 'calc(100vh - 22rem)'"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            color: '#6C6839',
            'text-align': 'center',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          v-el-table-infinite-scroll="load"
          v-loading="loading"
          infinite-scroll-disabled="onLoading"
          :span-method="cellMerge"
        >
          <!-- <el-table-column prop="currten" width="80">
            <template slot-scope="scope">{{ scope.row.currten + 1 }}</template>
          </el-table-column> -->
          <el-table-column type="index" width="80"></el-table-column>
          <el-table-column prop="regionName" label="区域"> </el-table-column>
          <el-table-column prop="shopCode" label="门店"> </el-table-column>
          <el-table-column prop="name" label="姓名"> </el-table-column>
          <el-table-column prop="cardNo" label="卡号"> </el-table-column>
          <el-table-column
            prop="levelName_cn"
            label="会员等级"
          ></el-table-column>
          <el-table-column prop="empCode" label="维护人"></el-table-column>
          <el-table-column prop="bindQty" label="企微好友数量">
          </el-table-column>
          <el-table-column prop="chatUserList_flag" label="">
            <template slot-scope="scope">
              {{
                scope.row.chatUserList_flag === 0
                  ? "本店"
                  : scope.row.chatUserList_flag === 1
                  ? "跨店"
                  : scope.row.chatUserList_flag === 2
                  ? "跨区"
                  : scope.row.chatUserList_flag === 3
                  ? "其他"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="chatUserList_weChatName"
            label="企微好友名称"
          ></el-table-column>
          <el-table-column
            prop="chatUserList_weChatShopName"
            label="部门or门店"
          ></el-table-column>
          <el-table-column
            prop="chatUserList_custWeChatRemark"
            label="好友备注"
          ></el-table-column>
        </el-table>
        <el-alert
          v-if="isMore"
          title="没有更多啦!"
          type="warning"
          center
          show-icon
          :closable="false"
        ></el-alert>
      </el-card>
    </div>
    <!-- 筛选条件弹窗 -->
    <el-dialog
      append-to-body
      width="1200px"
      :visible.sync="conditionDialog"
      :close-on-click-modal="false"
    >
      <el-row>
        <el-col :span="12">
          <el-form
            :model="queryInfo"
            size="small"
            :inline="true"
            label-width="130px"
          >
            <el-form-item label="卡号">
              <el-input v-model="queryInfo.cardNo"></el-input>
            </el-form-item>
            <el-form-item label="姓名">
              <el-input v-model="queryInfo.userName"></el-input>
            </el-form-item>
            <el-form-item label="电话号码">
              <el-input v-model="queryInfo.Mobile"></el-input>
            </el-form-item>
            <el-form-item label="维护区域">
              <el-select
                v-model="queryInfo.regionIds"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="item in Regioncax"
                  :key="item.id"
                  :label="item.lable"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="维护店1">
              <el-col :span="16">
                <textarea rows="8" v-model="ServiceOrgName" readonly></textarea>
              </el-col>
              <el-col :span="8">
                <el-button
                  style="margin-left: 10px"
                  @click="
                    (outletVisible = true),
                      (flag = 3),
                      (shopId = queryInfo.shopIds)
                  "
                  >选择门店</el-button
                >
              </el-col>
            </el-form-item>
            <el-form-item label="维护人">
              <el-input v-model="queryInfo.ServiceEmpName"></el-input>
            </el-form-item>
            <el-form-item label="注册日期">
              <el-date-picker
                v-model="dateValue1"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="省份">
              <el-input v-model="queryInfo.provinceName"></el-input>
            </el-form-item>
            <el-form-item label="城市">
              <el-input v-model="queryInfo.cityName"></el-input>
            </el-form-item>
            <el-form-item label="会员等级">
              <el-select
                style="width: 100%"
                multiple
                v-model="queryInfo.LevelID"
              >
                <el-option
                  v-for="item in checkbooksData"
                  :key="item.levelID"
                  :value="item.levelID"
                  :label="item.levelName_cn"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="生日所在月份">
              <div class="flex-between">
                <el-select
                  style="width: 45%"
                  v-model="queryInfo.birthMonthStart"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in months"
                    :key="item"
                    :label="item + '月'"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-select
                  style="width: 45%"
                  v-model="queryInfo.birthMonthEnd"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in months"
                    :key="item"
                    :label="item + '月'"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="生日所在日期">
              <div class="flex-between">
                <el-select
                  style="width: 45%"
                  v-model="queryInfo.birthDateStart"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in days"
                    :key="item"
                    :label="item + '日'"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-select
                  style="width: 45%"
                  v-model="queryInfo.birthDateEnd"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in days"
                    :key="item"
                    :label="item + '日'"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="年龄">
              <div class="flex-between">
                <el-input v-model="queryInfo.ageMin"></el-input>
                <span style="margin: 0 1rem 0 1rem">到</span>
                <el-input v-model="queryInfo.ageMax"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="最近购买日">
              <el-date-picker
                v-model="dateValue3"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="会员TAG">
              <el-select
                v-model="queryInfo.tagIds"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="item in memberTagList"
                  :key="item.userDefineID"
                  :label="item.description_CN"
                  :value="item.userDefineID"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否商城VIP">
              <el-select v-model="queryInfo.isMillVIP" placeholder="请选择">
                <el-option value="" label="所有"></el-option>
                <el-option value="1" label="是"></el-option>
                <el-option value="0" label="否"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="非分配维护人">
              <el-select v-model="queryInfo.isServiceEmp" placeholder="请选择">
                <el-option value="" label="所有"></el-option>

                <el-option value="1" label="已分配"></el-option>

                <el-option value="0" label="未分配"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="今年消费额">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.CurrYearAmountMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.CurrYearAmountMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="去年消费额">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.PrevYearAmountMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.PrevYearAmountMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="最近一年消费额">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.LastYearAmountMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.LastYearAmountMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
          </el-form>
        </el-col>

        <el-col :span="12">
          <el-form
            :model="queryInfo"
            size="small"
            :inline="true"
            label-width="130px"
          >
            <el-form-item label="TOP1客单价">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.SheetTopAmt1Min"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.SheetTopAmt1Max"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="TOP2客单价">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.SheetTopAmt2Min"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.SheetTopAmt2Max"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="TOP3客单价">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.SheetTopAmt3Min"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.SheetTopAmt3Max"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="M期间消费金额">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.MonetaryMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.MonetaryMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="F期间消费次数">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.FrequencyMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.FrequencyMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="T期间的最大单">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.TMaxMoneyMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.TMaxMoneyMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="RMF标签">
              <div class="flex-between">
                <el-select
                  style="width: 100%"
                  multiple
                  v-model="queryInfo.saleTagID"
                >
                  <el-option
                    v-for="item in levelRmfList"
                    :key="item.sortIndex"
                    :value="item.sortIndex"
                    :label="item.description_CN"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="当前是否保级">
              <div class="flex-between">
                <el-select
                  v-model="queryInfo.HasRelegation"
                  placeholder="请选择"
                >
                  <el-option value="" label="所有"></el-option>
                  <el-option value="1" label="是"></el-option>

                  <el-option value="0" label="否"> </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="保级日期">
              <el-date-picker
                v-model="protectionDate"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="当前可能降级级别">
              <div class="flex-between">
                <el-select
                  style="width: 100%"
                  multiple
                  v-model="queryInfo.CanDegradeLvl"
                >
                  <el-option
                    v-for="item in checkbooksData"
                    :key="item.levelID"
                    :value="item.levelID"
                    :label="item.levelName_cn"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="当前可用积分">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.CurrAvailPointMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.CurrAvailPointMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="去年累计积分">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.PreYearPointsMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.PreYearPointsMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="今年累计积分">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.CurrYearPointsMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.CurrYearPointsMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="升级为VIC的时间">
              <el-date-picker
                v-model="dateValue4"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="升级为VIC的机构">
              <el-col :span="16">
                <textarea
                  rows="8"
                  v-model="FirstVipOrgName"
                  readonly
                ></textarea>
              </el-col>
              <el-col :span="8">
                <el-button
                  style="margin-left: 10px"
                  @click="
                    (outletVisible = true),
                      (flag = 4),
                      (shopId = queryInfo.UpdateLvlOrgIds)
                  "
                  >选择门店</el-button
                >
              </el-col>
            </el-form-item>
            <el-form-item label="升级为VIC的区域">
              <el-select
                v-model="queryInfo.UpdateLvlRegionIds"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="item in Regioncax"
                  :key="item.id"
                  :label="item.lable"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="去年消费次数">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.PrevYearSaleTimesMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.PrevYearSaleTimesMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="今年消费次数">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.CurrYearSaleTimesMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.CurrYearSaleTimesMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="平均客单价">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.AvgSheetAmtMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.AvgSheetAmtMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="平均折扣">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.AvgDiscountMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.AvgDiscountMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="title">
        <div class="dialogTitle">
          <span>条件</span>
          <div></div>
          <div>
            <el-button @click="getList(), (conditionDialog = false)"
              >查 询</el-button
            >
            <el-button @click="eliminate(), (conditionDialog = false)"
              >清除查询条件</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 选择门店 -->
    <div class="outlet">
      <el-dialog
        :close-on-click-modal="false"
        width="35%"
        :visible.sync="outletVisible"
        title="选择门店"
        class="store-modal"
      >
        <el-form size="mini" label-width="90px">
          <el-row v-for="(item, index) in StoreSelectionList" :key="index">
            <el-col :span="12" v-for="(myitem, myindex) in item" :key="myindex">
              <el-tree
                ref="tree"
                v-if="myitem != undefined"
                :data="[myitem]"
                show-checkbox
                node-key="shopID"
                highlight-current
                default-expand-all
                :default-checked-keys="shopId"
                :props="defaultProps"
              >
              </el-tree>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="ComButtomStore">确 定</el-button>
          <el-button @click="outletVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 导出弹窗 -->
    <div class="exporttc">
      <el-dialog
        :close-on-click-modal="false"
        width="20%"
        title="导出客户企微好友关系报表"
        :visible.sync="exportShow"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否确定
            <span style="color: #ff0000">导出</span>客户企微好友关系报表?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Export">确 定</el-button>
          <el-button @click="exportShow = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 下载弹窗 -->
    <el-dialog
      append-to-body
      width="50%"
      :visible.sync="downloadShow"
      title="下载文件"
    >
      <el-table
        size="small"
        class="table-style"
        border
        :row-class-name="tableRowClassNameTow"
        :header-cell-style="{
          background: '#FCFBF2',
          'text-align': 'center',
          color: '#6C6839',
          fontSize: '14px',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="downloadData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="index" width="55"></el-table-column>
        <el-table-column
          prop="startTime"
          label="开始执行时间"
        ></el-table-column>

        <el-table-column prop="endTime" label="结束执行时间"></el-table-column>

        <el-table-column prop="fileName" label="文件名"></el-table-column>

        <el-table-column prop="isComplate" label="状态">
          <template slot-scope="scope">
            {{ scope.row.isComplate ? "完成" : "执行中" }}
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="下载">
          <template slot-scope="scope">
            <el-button
              icon="el-icon-download"
              v-if="scope.row.isComplate"
              @click="download(scope.row.downloadUrl)"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  RegionApi,
  EnterpriseWeChatFriendshipExportApi,
  EnterpriseWeChatFriendshipListApi,
  reportFormList,
} from "@/api/reportForm";
import { definedQueryListApi } from "@/api/region";
import { queryLSelectApi, queryRmfSelectApi } from "@/api/user"; // 会员等级接口
import { regionalQuery } from "@/api/huiyuanyy"; //区域
import { getcpyNo } from "@/utils/auth";
export default {
  name: "EnterpriseWeChatFriendship",
  data() {
    return {
      jurisdiction: {
        search: false,
        export: false,
      },
      downloadData: [],
      downloadShow: false,
      exportShow: false,
      conditionDialog: false,
      key: "",
      // 首页列表内容
      tableData: [],
      // 首页loading
      loading: false,
      dateValue1: [], //注册日期
      dateValue3: [], //最近购买日
      dateValue4: [], //创建日期
      protectionDate: [], //保级日期
      queryInfo: {
        pageNum: 1,
        pageSize: 40,
        cusInfo: "", // 姓名,卡号,手机
        multipleQty: false,
        checkList: ["本店", "跨区", "跨店", "其他"],
        RegistDateStart: "", // 注册开始时间
        RegistDateEnd: "", // 注册结束时间
        CreateTimeStart: "", // 创建时间开始
        CreateTimeEnd: "", // 创建时间结束
        regionIds: [], // 维护区域
        LevelID: [], // 等级
        cardNo: "", // 卡号
        userName: "", // 姓名
        Mobile: "", // 电话号码
        shopIds: [], // 维护店
        provinceName: "", // 省
        ServiceEmpName: "", // 维护人
        cityName: "", // 市
        birthMonthStart: "",
        birthMonthEnd: "",
        birthDateStart: "",
        birthDateEnd: "",
        ageMin: "",
        ageMax: "",
        LastSaleDateStart: "", // 最近购买日
        LastSaleDateEnd: "", // 最近购买日
        tagIds: [], // 会员TAG
        isMillVIP: "", // 是否商城VIP
        isServiceEmp: "", // 非分配维护人
        CurrYearAmountMin: "", // 今年消费额
        CurrYearAmountMax: "", // 今年消费额
        PrevYearAmountMin: "", // 去年消费额
        PrevYearAmountMax: "", // 去年消费额
        LastYearAmountMin: "", // 最近一年消费额
        LastYearAmountMax: "", // 最近一年消费额
        SheetTopAmt1Min: "", // TOP1客单价
        SheetTopAmt1Max: "", // TOP1客单价
        SheetTopAmt2Min: "", // TOP2客单价
        SheetTopAmt2Max: "", // TOP2客单价
        SheetTopAmt3Min: "", // TOP3客单价
        SheetTopAmt3Max: "", // TOP3客单价
        MonetaryMin: "", // M期间消费金额
        MonetaryMax: "", // M期间消费金额
        FrequencyMin: "", // F期间消费次数
        FrequencyMax: "", // F期间消费次数
        TMaxMoneyMin: "", // T期间最大单
        TMaxMoneyMax: "", // T期间最大单
        saleTagID: "", //RMF标签
        HasRelegation: "", // 当前是否已保级
        CanDegradeLvl: "", // 当前可能降级级别
        CurrAvailPointMin: "", // 当前可用积分
        CurrAvailPointMax: "", // 当前可用积分
        PreYearPointsMin: "", // 去年累计积分
        PreYearPointsMax: "", // 去年累计积分
        CurrYearPointsMin: "", // 今年累计积分
        CurrYearPointsMax: "", // 今年累计积分
        FirstVipDateStart: "", // 升级为VIC的时间
        FirstVipDateEnd: "", // 升级为VIC的时间
        lvlExpireDateStart: "",
        lvlExpireDateEnd: "",
        UpdateLvlOrgIds: [], // 升级为VIC的机构
        UpdateLvlRegionIds: [], // 升级为VIC的区域
        PrevYearSaleTimesMin: "", // 去年消费次数
        PrevYearSaleTimesMax: "", // 去年消费次数
        CurrYearSaleTimesMin: "", // 今年消费次数
        CurrYearSaleTimesMax: "", // 今年消费次数
        AvgSheetAmtMin: "", // 平均客单价
        AvgSheetAmtMax: "", // 平均客单价
        AvgDiscountMin: "", // 平均折扣
        AvgDiscountMax: "", // 平均折扣
      },
      checkbooksData: [], //会员等级
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      outletVisible: false,
      // 选择门店数据
      shopId: [],
      StoreSelectionList: [],
      StoredataArray: [],
      StoreSelectLength: 0,
      defaultProps: {
        children: "chlidren",
        label: "lable",
      },
      flag: 0,
      Regioncax: [], //区域
      memberTagList: [],
      ServiceOrgName: "", //维护店
      FirstVipOrgName: "", //升级为VIC的机构
      total: "", //总记录数
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      days: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
      ],
      levelRmfList: [],
      spanArr: [],
      spanArrTow: [],
    };
  },
  created() {
    queryRmfSelectApi({ defineKindID: -1 }).then(
      (res) => (this.levelRmfList = res.data)
    );
    let arrDkDs = [13];
    definedQueryListApi({ defineKindIDs: arrDkDs.join(",") }).then((res) => {
      this.memberTagList = res.data["13"] || []; // 会员TAG
    });
    this.ShopqueryRegionList();
    this.regioNalinformation();
    this.getList();
    queryLSelectApi({ cpyNO: getcpyNo() }).then((res) => {
      this.checkbooksData = res.data;
    });
    let EnterpriseWeChatFriendship = JSON.parse(
      localStorage.getItem("EnterpriseWeChatFriendship")
    );
    for (let i = 0; i < EnterpriseWeChatFriendship.length; i++) {
      if (EnterpriseWeChatFriendship[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (EnterpriseWeChatFriendship[i].menuName == "导出") {
        this.jurisdiction.export = true;
        continue;
      }
    }
  },
  computed: {
    isMore() {
      return this.queryInfo.pageNum * this.queryInfo.pageSize >= this.total;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
  },
  methods: {
    //获取下载列表数据
    getDownladList() {
      reportFormList({
        groupName: "客户企微好友关系报表",
      }).then((response) => {
        this.downloadData = response.data;
      });
    },
    download(src) {
      this.exportShow = false;
      const ele = document.createElement("a");
      ele.style.display = "none";
      ele.href = src;
      ele.download = "";
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      ele.remove();
    },
    // 导出
    Export() {
      EnterpriseWeChatFriendshipExportApi(this.processingParams()).then(() => {
        this.exportShow = false;
        this.$message.success("导出成功请在下载列表查看!");
      });
    },
    // 清除查询筛选条件
    eliminate() {
      this.queryInfo = {
        pageNum: 1,
        pageSize: 50,
        cusInfo: "", // 电话号码
        multipleQty: false,
        checkList: ["本店", "跨区", "跨店", "其他"],
        RegistDateStart: "", // 注册开始时间
        RegistDateEnd: "", // 注册结束时间
        CreateTimeStart: "", // 创建时间开始
        CreateTimeEnd: "", // 创建时间结束
        regionIds: [], // 维护区域
        LevelID: [], // 等级
        cardNo: "", // 卡号
        userName: "", // 姓名
        Mobile: "", // 电话号码
        shopIds: [], // 维护店
        provinceName: "", // 省
        ServiceEmpName: "", // 维护人
        cityName: "", // 市
        birthMonthStart: "",
        birthMonthEnd: "",
        birthDateStart: "",
        birthDateEnd: "",
        ageMin: "",
        ageMax: "",
        LastSaleDateStart: "", // 最近购买日
        LastSaleDateEnd: "", // 最近购买日
        tagIds: [], // 会员TAG
        isMillVIP: "", // 是否商城VIP
        isServiceEmp: "", // 非分配维护人
        CurrYearAmountMin: "", // 今年消费额
        CurrYearAmountMax: "", // 今年消费额
        PrevYearAmountMin: "", // 去年消费额
        PrevYearAmountMax: "", // 去年消费额
        LastYearAmountMin: "", // 最近一年消费额
        LastYearAmountMax: "", // 最近一年消费额
        SheetTopAmt1Min: "", // TOP1客单价
        SheetTopAmt1Max: "", // TOP1客单价
        SheetTopAmt2Min: "", // TOP2客单价
        SheetTopAmt2Max: "", // TOP2客单价
        SheetTopAmt3Min: "", // TOP3客单价
        SheetTopAmt3Max: "", // TOP3客单价
        MonetaryMin: "", // M期间消费金额
        MonetaryMax: "", // M期间消费金额
        FrequencyMin: "", // F期间消费次数
        FrequencyMax: "", // F期间消费次数
        TMaxMoneyMin: "", // T期间最大单
        TMaxMoneyMax: "", // T期间最大单
        saleTagID: "", //RMF标签
        HasRelegation: "", // 当前是否已保级
        CanDegradeLvl: "", // 当前可能降级级别
        CurrAvailPointMin: "", // 当前可用积分
        CurrAvailPointMax: "", // 当前可用积分
        PreYearPointsMin: "", // 去年累计积分
        PreYearPointsMax: "", // 去年累计积分
        CurrYearPointsMin: "", // 今年累计积分
        CurrYearPointsMax: "", // 今年累计积分
        FirstVipDateStart: "", // 升级为VIC的时间
        FirstVipDateEnd: "", // 升级为VIC的时间
        lvlExpireDateStart: "",
        lvlExpireDateEnd: "",
        UpdateLvlOrgIds: [], // 升级为VIC的机构
        UpdateLvlRegionIds: [], // 升级为VIC的区域
        PrevYearSaleTimesMin: "", // 去年消费次数
        PrevYearSaleTimesMax: "", // 去年消费次数
        CurrYearSaleTimesMin: "", // 今年消费次数
        CurrYearSaleTimesMax: "", // 今年消费次数
        AvgSheetAmtMin: "", // 平均客单价
        AvgSheetAmtMax: "", // 平均客单价
        AvgDiscountMin: "", // 平均折扣
        AvgDiscountMax: "", // 平均折扣
      };
      this.dateValue1 = []; //注册日期
      this.dateValue3 = []; //最近购买日
      this.dateValue4 = []; //创建日期
      this.protectionDate= []; //保级日期
      this.ServiceOrgName = ""; //维护店
      this.FirstVipOrgName = ""; //升级为VIC的机构
      this.tableData = [];
      this.getList();
      this.$message.success("清除查询条件成功!");
    },
    // 首页列表
    async getList(pagingType = true) {
      this.loading = true;
      EnterpriseWeChatFriendshipListApi(this.processingParams())
        .then((res) => {
          if (pagingType) this.tableData = [];
          res.data.list.forEach((item) => {
            item.chatUserList = item.chatUserList.sort(this.sortFunction());
          });
          let copyList = [];
          res.data.list.forEach((item, index) => {
            item.chatUserList.forEach((item2) => {
              copyList.push({
                currten: index,
                ...item,
                chatUserList_flag: item2.flag,
                chatUserList_weChatName: item2.weChatName,
                chatUserList_weChatShopName: item2.weChatShopName,
                chatUserList_custWeChatRemark: item2.custWeChatRemark,
              });
            });
          });
          this.getSpanArr(this.tableData.concat(copyList));
          this.getSpanArrTow(this.tableData.concat(copyList));
          this.tableData = this.tableData.concat(copyList);
          this.total = res.data.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cellMerge({ rowIndex, columnIndex }) {
      if ([1, 2, 3, 4, 5, 6, 7].includes(columnIndex)) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      } else if (columnIndex === 8) {
        const _row = this.spanArrTow[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    getSpanArrTow(data) {
      this.spanArrTow = [];
      let posTow = 0;
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArrTow.push(1);
          posTow = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          if (
            data[i].currten === data[i - 1].currten &&
            data[i].chatUserList_flag === data[i - 1].chatUserList_flag
          ) {
            this.spanArrTow[posTow] += 1;
            this.spanArrTow.push(0);
          } else {
            this.spanArrTow.push(1);
            posTow = i;
          }
        }
      }
    },
    getSpanArr(data) {
      this.spanArr = [];
      let pos = 0;
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          pos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          if (data[i].currten === data[i - 1].currten) {
            this.spanArr[pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            pos = i;
          }
        }
      }
    },
    sortFunction() {
      return (m, n) => {
        let key = "flag";
        return m[key] - n[key];
      };
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.queryInfo.pageNum += 1;
        this.getList(false);
      }, 1000);
    },
    //参数处理
    processingParams() {
      if (this.dateValue1 && this.dateValue1.length > 0) {
        this.queryInfo.RegistDateStart = this.renderTime(
          this.dateValue1[0]
        ).substring(0, 10);
        this.queryInfo.RegistDateEnd = this.renderTime(
          this.dateValue1[1]
        ).substring(0, 10);
      } else {
        this.queryInfo.RegistDateStart = undefined;
        this.queryInfo.RegistDateEnd = undefined;
      }
      if (this.dateValue3 && this.dateValue3.length > 0) {
        this.queryInfo.LastSaleDateStart = this.renderTime(
          this.dateValue3[0]
        ).substring(0, 10);
        this.queryInfo.LastSaleDateEnd = this.renderTime(
          this.dateValue3[1]
        ).substring(0, 10);
      } else {
        this.queryInfo.LastSaleDateStart = undefined;
        this.queryInfo.LastSaleDateEnd = undefined;
      }
      if (this.dateValue4 && this.dateValue4.length > 0) {
        this.queryInfo.FirstVipDateStart = this.renderTime(
          this.dateValue4[0]
        ).substring(0, 10);
        this.queryInfo.FirstVipDateEnd = this.renderTime(
          this.dateValue4[1]
        ).substring(0, 10);
      } else {
        this.queryInfo.FirstVipDateStart = undefined;
        this.queryInfo.FirstVipDateEnd = undefined;
      }
      // 保级日期
      if (this.protectionDate && this.protectionDate.length > 0) {
        this.queryInfo.lvlExpireDateStart = this.renderTime(
          this.protectionDate[0]
        ).substring(0, 10);
        this.queryInfo.lvlExpireDateEnd = this.renderTime(
          this.protectionDate[1]
        ).substring(0, 10);
      } else {
        this.queryInfo.lvlExpireDateStart = "";
        this.queryInfo.lvlExpireDateEnd = "";
      }
      let data = {
        pageNum: this.queryInfo.pageNum,
        pageSize: this.queryInfo.pageSize,
        search:
          this.queryInfo.cusInfo == "" ? undefined : this.queryInfo.cusInfo,
        serviceShopIds:
          this.queryInfo.shopIds.length == 0
            ? undefined
            : this.queryInfo.shopIds,
        multipleQty: this.queryInfo.multipleQty == true ? 1 : "",
        registDateStart: this.queryInfo.RegistDateStart,
        registDateEnd: this.queryInfo.RegistDateEnd,
        serviceRegionIds:
          this.queryInfo.regionIds.length == 0
            ? undefined
            : this.queryInfo.regionIds,
        levelIDs:
          this.queryInfo.LevelID.length == 0
            ? undefined
            : this.queryInfo.LevelID,
        cardNo: this.queryInfo.cardNo == "" ? undefined : this.queryInfo.cardNo,
        name:
          this.queryInfo.userName == "" ? undefined : this.queryInfo.userName,
        mobile: this.queryInfo.Mobile == "" ? undefined : this.queryInfo.Mobile,
        provinceName:
          this.queryInfo.provinceName == ""
            ? undefined
            : this.queryInfo.provinceName,
        serviceEmpName:
          this.queryInfo.ServiceEmpName == ""
            ? undefined
            : this.queryInfo.ServiceEmpName,
        cityName:
          this.queryInfo.cityName == "" ? undefined : this.queryInfo.cityName,
        birthMonthStart: this.queryInfo.birthMonthStart,
        birthMonthEnd: this.queryInfo.birthMonthEnd,
        birthDateStart: this.queryInfo.birthDateStart,
        birthDateEnd: this.queryInfo.birthDateEnd,
        ageMin: this.queryInfo.ageMin,
        ageMax: this.queryInfo.ageMax,
        lastSaleDateStart: this.queryInfo.LastSaleDateStart,
        lastSaleDateEnd: this.queryInfo.LastSaleDateEnd,
        tagIds:
          this.queryInfo.tagIds.length == 0 ? undefined : this.queryInfo.tagIds,
        isMillVIP:
          this.queryInfo.isMillVIP == "" ? undefined : this.queryInfo.isMillVIP,
        isServiceEmp:
          this.queryInfo.isServiceEmp == ""
            ? undefined
            : this.queryInfo.isServiceEmp,
        currYearAmountMin:
          this.queryInfo.CurrYearAmountMin == ""
            ? undefined
            : this.queryInfo.CurrYearAmountMin,
        currYearAmountMax:
          this.queryInfo.CurrYearAmountMax == ""
            ? undefined
            : this.queryInfo.CurrYearAmountMax,
        prevYearAmountMin:
          this.queryInfo.PrevYearAmountMin == ""
            ? undefined
            : this.queryInfo.PrevYearAmountMin,
        prevYearAmountMax:
          this.queryInfo.PrevYearAmountMax == ""
            ? undefined
            : this.queryInfo.PrevYearAmountMax,
        lastYearAmountMin:
          this.queryInfo.LastYearAmountMin == ""
            ? undefined
            : this.queryInfo.LastYearAmountMin,
        lastYearAmountMax:
          this.queryInfo.LastYearAmountMax == ""
            ? undefined
            : this.queryInfo.LastYearAmountMax,
        sheetTopAmt1Min:
          this.queryInfo.SheetTopAmt1Min == ""
            ? undefined
            : this.queryInfo.SheetTopAmt1Min,
        sheetTopAmt1Max:
          this.queryInfo.SheetTopAmt1Max == ""
            ? undefined
            : this.queryInfo.SheetTopAmt1Max,
        sheetTopAmt2Min:
          this.queryInfo.SheetTopAmt2Min == ""
            ? undefined
            : this.queryInfo.SheetTopAmt2Min,
        sheetTopAmt2Max:
          this.queryInfo.SheetTopAmt2Max == ""
            ? undefined
            : this.queryInfo.SheetTopAmt2Max,
        sheetTopAmt3Min:
          this.queryInfo.SheetTopAmt3Min == ""
            ? undefined
            : this.queryInfo.SheetTopAmt3Min,
        sheetTopAmt3Max:
          this.queryInfo.SheetTopAmt3Max == ""
            ? undefined
            : this.queryInfo.SheetTopAmt3Max,
        monetaryMin:
          this.queryInfo.MonetaryMin == ""
            ? undefined
            : this.queryInfo.MonetaryMin,
        monetaryMax:
          this.queryInfo.MonetaryMax == ""
            ? undefined
            : this.queryInfo.MonetaryMax,
        frequencyMin:
          this.queryInfo.FrequencyMin == ""
            ? undefined
            : this.queryInfo.FrequencyMin,
        frequencyMax:
          this.queryInfo.FrequencyMax == ""
            ? undefined
            : this.queryInfo.FrequencyMax,
        tMaxMoneyMin:
          this.queryInfo.TMaxMoneyMin == ""
            ? undefined
            : this.queryInfo.TMaxMoneyMin,
        tMaxMoneyMax:
          this.queryInfo.TMaxMoneyMax == ""
            ? undefined
            : this.queryInfo.TMaxMoneyMax,
        saleTagID:
          this.queryInfo.saleTagID == "" ? undefined : this.queryInfo.saleTagID, //RMF标签
        hasRelegation:
          this.queryInfo.HasRelegation == ""
            ? undefined
            : this.queryInfo.HasRelegation,
        canDegradeLvl:
          this.queryInfo.CanDegradeLvl == ""
            ? undefined
            : this.queryInfo.CanDegradeLvl,
        currAvailPointMin:
          this.queryInfo.CurrAvailPointMin == ""
            ? undefined
            : this.queryInfo.CurrAvailPointMin,
        currAvailPointMax:
          this.queryInfo.CurrAvailPointMax == ""
            ? undefined
            : this.queryInfo.CurrAvailPointMax,
        preYearPointsMin:
          this.queryInfo.PreYearPointsMin == ""
            ? undefined
            : this.queryInfo.PreYearPointsMin,
        preYearPointsMax:
          this.queryInfo.PreYearPointsMax == ""
            ? undefined
            : this.queryInfo.PreYearPointsMax,
        currYearPointsMin:
          this.queryInfo.CurrYearPointsMin == ""
            ? undefined
            : this.queryInfo.CurrYearPointsMin,
        currYearPointsMax:
          this.queryInfo.CurrYearPointsMax == ""
            ? undefined
            : this.queryInfo.CurrYearPointsMax,
        firstVipDateStart: this.queryInfo.FirstVipDateStart,
        firstVipDateEnd: this.queryInfo.FirstVipDateEnd,
        lvlExpireDateStart: this.queryInfo.lvlExpireDateStart,
        lvlExpireDateEnd: this.queryInfo.lvlExpireDateEnd,
        updateLvlOrgIds:
          this.queryInfo.UpdateLvlOrgIds.length == 0
            ? undefined
            : this.queryInfo.UpdateLvlOrgIds,
        updateLvlRegionIds:
          this.queryInfo.UpdateLvlRegionIds.length == 0
            ? undefined
            : this.queryInfo.UpdateLvlRegionIds,
        prevYearSaleTimesMin:
          this.queryInfo.PrevYearSaleTimesMin == ""
            ? undefined
            : this.queryInfo.PrevYearSaleTimesMin,
        prevYearSaleTimesMax:
          this.queryInfo.PrevYearSaleTimesMax == ""
            ? undefined
            : this.queryInfo.PrevYearSaleTimesMax,
        currYearSaleTimesMin:
          this.queryInfo.CurrYearSaleTimesMin == ""
            ? undefined
            : this.queryInfo.CurrYearSaleTimesMin,
        currYearSaleTimesMax:
          this.queryInfo.CurrYearSaleTimesMax == ""
            ? undefined
            : this.queryInfo.CurrYearSaleTimesMax,
        avgSheetAmtMin:
          this.queryInfo.AvgSheetAmtMin == ""
            ? undefined
            : this.queryInfo.AvgSheetAmtMin,
        avgSheetAmtMax:
          this.queryInfo.AvgSheetAmtMax == ""
            ? undefined
            : this.queryInfo.AvgSheetAmtMax,
        avgDiscountMin:
          this.queryInfo.AvgDiscountMin == ""
            ? undefined
            : this.queryInfo.AvgDiscountMin,
        avgDiscountMax:
          this.queryInfo.AvgDiscountMax == ""
            ? undefined
            : this.queryInfo.AvgDiscountMax,
      };
      let copyData = {};
      data["bindShop"] = "";
      data["bindOverShop"] = "";
      data["bindOverRegion"] = "";
      data["bindOther"] = "";
      this.queryInfo.checkList.forEach((item) => {
        if (item == "本店") {
          data["bindShop"] = 1;
        } else if (item == "跨区") {
          data["bindOverRegion"] = 1;
        } else if (item == "跨店") {
          data["bindOverShop"] = 1;
        } else if (item == "其他") {
          data["bindOther"] = 1;
        }
      });
      for (const key in data) {
        if (data[key] || [0, "0"].includes(data[key])) {
          copyData[key] = data[key];
        }
      }
      return copyData;
    },
    ShopqueryRegionList() {
      RegionApi().then((res) => {
        let arr1 = [],
          arr2 = [];
        if (res.success) {
          res.data.forEach((item) => {
            if (item.chlidren.length > 0) this.StoredataArray.push(item);
          });
          this.StoredataArray.forEach((item, index) => {
            item.chlidren.forEach((item) => {
              item.shopID = item.id;
            });
            this.StoreSelectLength += 1;
            if (index % 2 == 0) {
              arr1.push(item);
            } else {
              arr2.push(item);
            }
          });
          this.StoreSelectionList = arr1.map((key, value) => [
            key,
            arr2[value],
          ]);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    ComButtomStore() {
      // 获取已选择的门店数据
      let listOfSomeStoresl = [];
      let listOfSomeStoreslStr = "";
      for (let index = 0; index < this.StoreSelectLength; index++) {
        let item = this.$refs.tree[index].getCheckedNodes();
        if (item.length == this.StoredataArray[index].chlidren.length + 1) {
          listOfSomeStoresl.push(...this.StoredataArray[index].chlidren);
        } else {
          listOfSomeStoresl.push(...item);
        }
      }
      listOfSomeStoresl.forEach((item) => {
        listOfSomeStoreslStr += `${item.lable}\n`;
      });
      let shopId = []; //选中门店数据
      for (let i = 0; i < listOfSomeStoresl.length; i++) {
        shopId.push(listOfSomeStoresl[i].id);
      }
      if (this.flag == 3) {
        this.ServiceOrgName = listOfSomeStoreslStr;
        this.queryInfo.shopIds = shopId;
      } else if (this.flag == 4) {
        this.FirstVipOrgName = listOfSomeStoreslStr;
        this.queryInfo.UpdateLvlOrgIds = shopId;
      }
      this.outletVisible = false;
    },
    // 数字千分位格式化
    toThousands(num) {
      num = num + "";
      return num.replace(/\d+/, function (n) {
        return n.replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
      });
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ row }) {
      if (row.currten % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    tableRowClassNameTow({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    // 区域渲染数据
    async regioNalinformation() {
      const res = await regionalQuery({ regionID: "" });
      this.Regioncax = res.data;
    },
    renderTime(date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
}
.dialogTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 50px;
}
.dialogTitle > span {
  font-size: 16px;
  font-weight: 700;
  color: #6c6937;
}
/deep/.el-dialog__header {
  padding: 1.25rem 1.25rem 0.625rem;
  background-color: #d1cda5;
}
.dialog-footer {
  height: 40px;
  display: flex;
  justify-content: space-around;
}
/deep/.el-dialog__footer {
  height: 60px;
  text-align: center;
  background-color: #f2f2f2;
}
/deep/.inputtt .el-input__inner {
  overflow: hidden;
  /* white-space: nowrap; */
  text-overflow: ellipsis;
}
#alterations {
  height: 100%;
}
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}
.searchform {
  margin-top: 20px;
}
.centercard {
  margin-top: 10px;
}
.card-pagination {
  margin-top: 20px;
  text-align: right;
}
// 按钮边框去掉，文字颜色和加粗
/deep/ button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/ .table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}
/deep/ .red {
  color: red !important;
}
/deep/ .el-table .el-table__cell {
  text-align: center;
}
</style>
